<template>
  <div
    :class="$style.root"
  >
    <swiper
      :auto-height="true"
      :centered-slides="true"
      @swiper="onSwiper"
      @slideChange="handleOnSlideChange"
    >
      <template #container-end>
        <div :class="$style.nav" v-if="slidesCount > 1">
          <CoreSwiperPrevNextButtonComponent dir="prev" />
          <CoreSwiperPrevNextButtonComponent dir="next" />
        </div>
      </template>
      <slot />
    </swiper>
  </div>
</template>

<script>
import 'swiper/css'
import { Swiper, SwiperSlide } from 'swiper/vue'

export default {
  props: {
    slideToIndex: Number
  },
  watch: {
    slideToIndex: {
      immediate: false,
      handler (value) {
        this?.swiperInstance?.slideTo(value)
      }
    }
  },
  components: {
    Swiper,
    SwiperSlide
  },
  setup () {
    const swiperInstance = ref(null)
    const onSwiper = (swiper) => {
      swiperInstance.value = swiper
    }

    return {
      onSwiper,
      swiperInstance,
      modules: []
    }
  },
  computed: {
    slidesCount () {
      return this.swiperInstance?.slides?.length
    }
  },
  mounted () {
    if (this?.slidesCount === 1) {
      this.swiperInstance.disable()
    }
  },
  beforeUnmount () {
    this.swiperInstance?.destroy()
  },
  methods: {
    handleOnSlideChange () {
      this.$emit('set-active-index', this.swiperInstance?.activeIndex)
    },
    // slideToIndex (index) {
    //   this.swiperInstance?.slideTo(index)
    // }
  }
}
</script>

<style module>
.root {
}

.root :global(.swiper) {
  position: relative;
  /* NOTE to compensate for miscalculations */
  clip-path: inset(0 1px 0 1px);
}

.root :global(.swiper-wrapper) {
  /* NOTE to overwrite height transition */
  transition-property: transform !important;
}

.nav {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: var(--padding--element);

  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;

  z-index: 1;
  pointer-events: none;
}

.nav * {
  pointer-events: all;
}
</style>
